import type { TAuditLogEntityType } from 'api/swagger';

export const AUDIT_ENTITY_NAMES: Record<TAuditLogEntityType, string> = {
  cargo: 'cargo',
  cargo_item: 'cargo item',
  cargo_trip: 'cargo trip',
  client: 'client',
  client_insurance: 'client insurance',
  contact: 'contact',
  document: 'document',
  expense: 'expense',
  invoice: 'invoice',
  order: 'order',
  transport: 'transport',
  trip: 'trip',
  trip_task: 'trip task',
  warehouse: 'warehouse',
};
